import qs from 'qs'

const state = {
    sex: "",
    answers: "",
    strPersonal: []
}



// 0 - 0 - text - имя
// 1 - 0 - text - фамилия
// 2 - 0 - text - отчетство
// 3 - 0 - text - пол
// 4 - 0 - date - др
// 5 - 0 - text - паспорт серия
// 6 - 0 - text - паспорт номер
// 7 - 0 - date - дата паспорта
// 8 - 0 - text - снилс
// 9 - 0 - text - полис
// 10 - 1 - "" - страховая
// 11 - 0 - text - почта
// 12 - 1 - "" - тип телефона 
// 13 - 0 - text - телефон
// 14 - 1 - "" - тип адреса
// 15 - 1 - "" - регион
// 16 - 0 - text - населенный пункт
// 17 - 0 - text - улица
// 18 - 0 - text - дом
// 19 - 0 - text - квартира



const getters = {
    interviewAnswers: (state, getters, rootState) => {
        return JSON.stringify(Object.assign({}, rootState.defaultParams, {
                Name_module: 'medAdmin',
                Name_event: 'POST:poll_answers',
                // id_people: rootState.userData.id_people,
                str_param: state.strPersonal

        }))
    },
    
}


const mutations = {
    SetSex(state, payload) {
        state.sex = payload;
    },
    SetPersonal(state, payload) {
        state.strPersonal = payload;
    }
}

const actions = {
    sendUserAnswers: async({commit, state, getters}, answers) => {
        commit('SetPersonal', answers);
        console.log(getters.interviewAnswers)
        try {
            let res = await fetch(`https://host1.medsafe.tech:50443/api/covid`, {
                method: "POST", 
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: qs.stringify({
                    json: getters.interviewAnswers
                })
            });
            if (res.status >= 200 && res.status < 300) {
                commit('INTERVIEW_STATUS', await res.json());
            }
        } catch(err) { err => console.error(err) }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }


// WEBPACK FOOTER //
// ./src/store/modules/interview.js